import { Component, type ReactNode } from 'react';

import { settingsWindowLogError } from './log';

interface Props {
  children: ReactNode;
  fallback: ReactNode;
}

interface State {
  failed: boolean;
}

/**
 * A contributed settings section that throws during render. The exception
 * stays in the log; the pane renders `fallback` (empty for a settings section).
 */
export class SettingsSectionErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: unknown): void {
    const reason = error instanceof Error ? error.message : String(error);
    settingsWindowLogError('settings window section render failed', {
      reason,
    });
  }

  render(): ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
